/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_UpperInputs */

const en_us2_profile_editors_split_upper = /** @type {(inputs: Profile_Editors_Split_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upper body`)
};

const pt_br2_profile_editors_split_upper = /** @type {(inputs: Profile_Editors_Split_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superiores`)
};

const es_419_profile_editors_split_upper = /** @type {(inputs: Profile_Editors_Split_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tren superior`)
};

const pt_pt2_profile_editors_split_upper = /** @type {(inputs: Profile_Editors_Split_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superiores`)
};

const fr_fr2_profile_editors_split_upper = /** @type {(inputs: Profile_Editors_Split_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut du corps`)
};

const de_de2_profile_editors_split_upper = /** @type {(inputs: Profile_Editors_Split_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberkörper`)
};

const it_it2_profile_editors_split_upper = /** @type {(inputs: Profile_Editors_Split_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte superiore`)
};

/**
* | output |
* | --- |
* | "Upper body" |
*
* @param {Profile_Editors_Split_UpperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_upper = /** @type {((inputs?: Profile_Editors_Split_UpperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_UpperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_upper(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_upper(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_upper(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_upper(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_upper(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_upper(inputs)
	return en_us2_profile_editors_split_upper(inputs)
});
export { profile_editors_split_upper as "profile-editors.split_upper" }